export default function HorizontalCategoryItem() {
    return (<div className="bg-secondary-500/70 h-20 w-28 inline-block mx-2 rounded-xl shadow mb-1 shadow-secondary-500/25 p-4 text-white">
        <i className="fa-solid fa-burger"></i>
        <p>فست فود</p>
    </div>)
}